import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Ads from "./Ads";

export default function NewsDetails() {
  const { id, category, slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        let url = "";
        let targetField = "article_id";

        switch (category) {
          case "mqalat":
            url = "https://ppmn.net/dash/api/main/Section";
            break;
          case "reports":
            url = "https://ppmn.net/dash/api/main/report/section";
            targetField = "report_id";
            break;
          case "daily-news":
            url = "https://ppmn.net/dash/api/daily/Section";
            break;
          default:
            url = `https://ppmn.net/dash/api/Get/CategoryArticles/${category}`;
            break;
        }

        const res = await fetch(url);
        const json = await res.json();

        const articles = Array.isArray(json) ? json : Array.isArray(json.data) ? json.data : [];
        const found = articles.find((item) => item[targetField]?.toString() === id);
        setArticle(found || null);
      } catch (error) {
        console.error("فشل في تحميل تفاصيل الخبر:", error);
        setArticle(null);
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id, category]);

  if (loading) return <div className="loader text-center py-5">جاري تحميل التفاصيل...</div>;
  if (!article) return <div className="text-center my-5 text-danger">الخبر غير موجود.</div>;

  return (
    <div className="container my-5">
      <Ads />
      <div className="row">
        <div className="col-12">
          <h2 className="mb-4 text-center text-md-center" style={{ fontSize: "1.8rem", lineHeight: "1.6" }}>
            {article.article_title || article.report_title}
          </h2>
          <img
            src={article.article_title_image || article.report_image}
            alt={article.article_title || article.report_title}
            className="img-fluid rounded mb-3 w-100"
            style={{ maxHeight: "500px", objectFit: "cover" }}
          />
          <div className="text-muted mb-4 text-center text-md-start" style={{ fontSize: "0.95rem" }}>
            {(article.article_published_before || article.publish_before || "") +
              " - بواسطة " +
              (article.user_name || "")}
          </div>
        </div>

        <div className="col-12">
          {article.article_content || article.report_content ? (
            <div
              className="article-body"
              style={{ fontSize: "1.05rem", lineHeight: "1.9" }}
              dangerouslySetInnerHTML={{
                __html: (article.article_content || article.report_content),
              }}
            />
          ) : (
            <p className="text-muted">لا يوجد محتوى متاح لهذا الخبر.</p>
          )}
        </div>
      </div>

      <style>{`
        .article-body img {
          max-width: 100%;
          height: auto;
          margin: 15px 0;
          display: block;
        }
        .article-body p {
          text-align: right;
        }
      `}</style>
    </div>
  );
}
